import { useState } from '@web-stories-wp/react';
import { useTransformHandler } from '../../components/transform';

// Canvas previews never enter the story or Draft's undo history.
const identity = (next) => next;

export default function useGradientPreview(id, select = identity) {
  const [preview, setPreview] = useState(null);
  useTransformHandler(
    id,
    (transform) => {
      if (transform === null) setPreview(null);
      else if (transform.gradientPreview)
        setPreview((current) => select(transform.gradientPreview, current));
    },
    [id, select]
  );
  return preview;
}

// Bootstrap a legacy HTML layer on its first range preview. Keep the first
// payload until content changes; SVG owns subsequent paint-only updates.
const selectRangeSession = (next, current) =>
  next?.content === current?.content ? current : next;
export function useRangeGradientPreview(id) {
  return useGradientPreview(id, selectRangeSession);
}
